import { render, staticRenderFns } from "./systemage.vue?vue&type=template&id=26751487&scoped=true&"
import script from "./systemage.vue?vue&type=script&lang=js&"
export * from "./systemage.vue?vue&type=script&lang=js&"
import style0 from "./systemage.vue?vue&type=style&index=0&id=26751487&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26751487",
  null
  
)

export default component.exports